module.exports = __webpack_public_path__ + "img/kiey-icon.614f53f9.svg";